// extracted by mini-css-extract-plugin
export default {"container-fluid":"ServiceReason_container-fluid__K56jL","heading":"ServiceReason_heading__qEAK-"};